<div class="user-detail-page">

  <!-- Breadcrumb -->
  <div class="breadcrumb-container">
    <qai-breadcrumb-list [items]="breadcrumbItems()" />
  </div>

  <!-- User Header -->
  <header class="user-header">
    <div class="user-info">
      <h1 class="user-name">{{ fullName() }}</h1>
      <p class="user-email">{{ email() }}</p>
    </div>
  </header>

  <!-- Assignments Card -->
  <div class="assignments-card">

    <!-- Card toolbar -->
    <div class="card-toolbar">
      <span class="assignment-count">
        <strong class="assignment-count__number">{{ assignmentCount() }}</strong>
        <span class="assignment-count__label">{{ i18nKeys.assignmentsCount | transloco }}</span>
      </span>
      <button
        qai-button
        shape="normal"
        kind="tertiary"
        size="small"
        [disabled]="addModalLoading()"
        (click)="onAddToAssignment()"
      >
        @if (addModalLoading()) {
          <qai-loading size="extraSmall" positionStart />
        } @else {
          <qai-icon kind="plus" positionStart />
        }
        {{ i18nKeys.addToAssignment | transloco }}
      </button>
    </div>

    <!-- Loading -->
    @if (isLoading()) {
      <div class="loading-container">
        <qai-loading [size]="loadingSize" />
      </div>
    }

    <!-- Table -->
    @if (!isLoading() && tableData().length > 0) {
      <qai-table
        #assignmentsTable
        [headers]="headers()"
        [data]="tableData()"
        [striped]="false"
        [isTooltipLoading]="isTooltipLoading()"
        [previousLabel]="i18nKeys.previousLabel | transloco"
        [nextLabel]="i18nKeys.nextLabel | transloco"
        (rowAction)="onRowAction($event)"
        (rowClick)="onRowClick($event)"
        (tooltipDataRequested)="onTooltipDataRequested($event)"
      />
    }

  </div>

</div>

<!-- Edit Team Associations Modal -->
<edit-team-associations-modal
  [open]="editTeamsModalOpen()"
  [assignmentName]="editTeamsAssignmentName()"
  [availableTeams]="userTeams()"
  [currentTeamUuids]="editTeamsCurrentUuids()"
  (closeModal)="onEditTeamsModalClose()"
  (teamsSaved)="onTeamAssociationsSaved($event)"
/>

<!-- Add to Assignment Modal -->
<add-to-assignment-modal
  [open]="addModalOpen()"
  [assignments]="addModalAssignments()"
  [userTeams]="userTeams()"
  (closeModal)="onAddModalClose()"
  (assigned)="onAssigned($event)"
/>
